import { useState } from "react";
import { FileSpreadsheet, Lock } from "lucide-react";
import { download } from "@/admin/hr/common";
import { Loading, Title, todayTR, useData } from "@/ops/ui";
import { ReportView } from "@/ops/admin/PatrolReport";

function ProjectReport({ p }) {
  const [day, setDay] = useState(todayTR());
  const [rep] = useData(`/ops/client/projects/${p.id}/patrol`, { day });
  return (
    <div>
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <input type="date" value={day} onChange={(e) => setDay(e.target.value)} className="field-input max-w-[200px]" data-testid="client-report-date" />
        <button onClick={() => download(`/ops/client/projects/${p.id}/patrol.xlsx`, `devriye-${day}.xlsx`, { params: { day } })} className="btn-outline !py-2" data-testid="client-report-xlsx"><FileSpreadsheet className="h-4 w-4" /> Excel indir</button>
      </div>
      <ReportView rep={rep} people={false} />
    </div>
  );
}

export default function ClientHome() {
  const [projects] = useData("/ops/client/projects");
  const [sel, setSel] = useState(null);
  if (!projects) return <Loading />;
  const p = sel || projects[0];
  return (
    <div>
      <Title title="Projelerim" desc="Size atanmış projeler ve paylaşılan devriye raporları." />
      {!projects.length ? <p className="rounded-lg border border-dashed border-zinc-300 bg-white p-6 text-sm text-zinc-500" data-testid="client-no-projects">Hesabınıza atanmış aktif proje bulunmuyor.</p> : (
        <>
          <div className="mb-4 flex flex-wrap gap-2">{projects.map((x) => <button key={x.id} onClick={() => setSel(x)} className={`rounded-full border px-4 py-1.5 text-sm font-semibold ${p.id === x.id ? "border-[color:var(--red)] bg-[color:var(--red)] text-white" : "border-zinc-300 bg-white"}`} data-testid={`client-project-${x.id}`}>{x.name}</button>)}</div>
          {p.share_patrols ? <ProjectReport key={p.id} p={p} /> : <p className="flex items-center gap-2 rounded-lg bg-white p-5 text-sm text-zinc-500" data-testid="client-not-shared"><Lock className="h-4 w-4" /> Bu projenin devriye raporları henüz sizinle paylaşılmadı.</p>}
        </>
      )}
    </div>
  );
}
